import { queryOptions, useMutation, useQuery } from '@tanstack/react-query';

import {
  getDownloadLink,
  getSearch,
  getSearchWithCategory,
  getStoreDiscount,
  incrementAdvertisementClick,
  incrementAdvertisementView,
} from '@/components/shared/services';
import { getDownloadLinkType, SearchType } from '@/components/shared/services/types';

import {
  GET_FREE_DOWNLOAD_LINK,
  GET_SEARCH,
  GET_SEARCH_WITH_CATEGORY,
  GET_STORE_DISCOUNT,
  INCREMENT_ADVERTISEMENT_CLICK,
  INCREMENT_ADVERTISEMENT_VIEW,
} from '@/constant/query-key';

export function useGetSearch({ params, enabled }: SearchType) {
  return useQuery({
    queryFn: () => getSearch({ params }),
    queryKey: [GET_SEARCH, params],
    enabled: enabled,
  });
}

export function useGetSearchWithCategory({ params, enabled }: SearchType) {
  return useQuery({
    queryFn: () => getSearchWithCategory({ params }),
    queryKey: [GET_SEARCH_WITH_CATEGORY],
    enabled: enabled,
  });
}

export function useGetFreeDownloadLink(productId: getDownloadLinkType) {
  return useQuery({
    queryFn: () => getDownloadLink(productId),
    queryKey: [GET_FREE_DOWNLOAD_LINK, productId],
    enabled: false,
  });
}

export const getStoreDiscountOptions = (slug: string) =>
  queryOptions({
    queryKey: [GET_STORE_DISCOUNT, slug],
    queryFn: () => getStoreDiscount(slug),
  });

export function useIncrementAdvertisementClick() {
  return useMutation({
    mutationFn: (id: string) => incrementAdvertisementClick(id),
    mutationKey: [INCREMENT_ADVERTISEMENT_CLICK],
  });
}

export function useIncrementAdvertisementView() {
  return useMutation({
    mutationFn: (id: string) => incrementAdvertisementView(id),
    mutationKey: [INCREMENT_ADVERTISEMENT_VIEW],
  });
}
